<table class="table table-striped table-sm details-table">
  <tbody>
    <tr>
      <th>Name</th>
      <td>Alexander Schwartz</td>
    </tr>
    <tr>
      <th>Anschrift</th>
      <td>
        Normannenstr. 6<br />
        81925 München<br />
        Deutschland
      </td>
    </tr>
    <tr>
      <th>Email</th>
      <td><a href="mailto:mail@aSchwartz.de">mail@aSchwartz.de</a></td>
    </tr>
    <tr>
      <th>Telefon</th>
      <td>+49 (0) 171 / 5432107</td>
    </tr>
    @if (showTaxNumber) {
      <tr>
        <th>Umsatzsteuer-Identifikationsnummer</th>
        <td>DE270827078</td>
      </tr>
    }
    @if (showBusinessInfo) {
      <tr>
        <th>Registrierungsnummer</th>
        <td>A21064834</td>
      </tr>
    }
    @if (showBusinessInfo) {
      <tr>
        <th>Gemeinde</th>
        <td>Bayerische Landeshauptstadt München</td>
      </tr>
    }
    @if (showBusinessInfo) {
      <tr>
        <th>Gemeindeschlüssel</th>
        <td>09162000</td>
      </tr>
    }
    @if (showMessenger) {
      <tr>
        <th>WhatsApp</th>
        <td><i class="fa fa-whatsapp"></i><a href="https://wa.me/+491715432107">+491715432107</a></td>
      </tr>
    }
    @if (showMessenger) {
      <tr>
        <th>Telegram</th>
        <td><i class="fa fa-telegram"></i>erSchistan</td>
      </tr>
    }
    @if (showMessenger) {
      <tr>
        <th>Facebook Messenger</th>
        <td><i class="fa fa-facebook"></i>ersch.istan</td>
      </tr>
    }
  </tbody>
</table>

@if (showMap) {
  <app-map [disabled]="true" [lat]="lat" [lng]="lng" [zoom]="14"></app-map>
}
